import { render, staticRenderFns } from "./passengerBoat.vue?vue&type=template&id=6cfaef5a&"
import script from "./passengerBoat.vue?vue&type=script&lang=js&"
export * from "./passengerBoat.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports